// Copyright (c) 2020 Proto Labs, Inc. All Rights Reserved.

import { IConfirmProfileInfo, IHeaderLink, ILinkLanguage, IPassWordStrengthIndicators, IProfileInfo } from '@/interfaces';

export class ProfileInfo implements IProfileInfo {
    title: string;
    firstName: string;
    lastName: string;
    companyName: string;
    countryCode: string;
    email: string;
    password: string;
    phoneNumber: string;
    phoneCountryCode: string;
    postalCode: string;
    locale: string;
    captchaToken: string;

    constructor(profileInfo?: IProfileInfo) {
        profileInfo = profileInfo ? profileInfo : ProfileInfo.defaultDto();
        this.title = profileInfo.title;
        this.firstName = profileInfo.firstName;
        this.lastName = profileInfo.lastName;
        this.companyName = profileInfo.companyName;
        this.countryCode = profileInfo.countryCode;
        this.email = profileInfo.email;
        this.password = profileInfo.password;
        this.phoneNumber = profileInfo.phoneNumber;
        this.phoneCountryCode = profileInfo.phoneCountryCode;
        this.postalCode = profileInfo.postalCode;
        this.locale = profileInfo.locale;
        this.captchaToken = '';
    }

    static defaultDto(): IProfileInfo {
        return {
            title: '',
            firstName: '',
            lastName: '',
            companyName: '',
            countryCode: '',
            email: '',
            password: '',
            phoneNumber: '',
            phoneCountryCode: '',
            postalCode: '',
            locale: '',
            captchaToken: '',
        };
    }

    static fromProfileGetDto(profileGetDto: any): ProfileInfo {
        const mappedDto = {
            title: profileGetDto.title,
            firstName: profileGetDto.firstName,
            lastName: profileGetDto.lastName,
            companyName: profileGetDto.company,
            countryCode: profileGetDto.country.code,
            email: profileGetDto.email,
            phoneNumber: profileGetDto.phone,
            phoneCountryCode: profileGetDto.phoneCountryCode,
            postalCode: profileGetDto.postalCode,
            locale: profileGetDto.language,
            password: '',
            captchaToken: '',
        };
        return new ProfileInfo(mappedDto);
    }

    static toConfirmProfileInfo(profileInfo: ProfileInfo): IConfirmProfileInfo {
        const dto = {
            firstName: profileInfo.firstName,
            lastName: profileInfo.lastName,
            title: profileInfo.title,
            company: profileInfo.companyName,
            country: profileInfo.countryCode,
            phoneCountry: profileInfo.phoneCountryCode,
            phone: profileInfo.phoneNumber,
            postalCode: profileInfo.postalCode,
        };
        return dto;
    }
}

export class PassWordStrengthIndicators implements IPassWordStrengthIndicators {
    hasCommonNames: boolean;
    hasRepetitiveOrSequential: boolean;
    tooShort: boolean;

    constructor(dto: IPassWordStrengthIndicators) {
        this.hasCommonNames = dto.hasCommonNames;
        this.hasRepetitiveOrSequential = dto.hasRepetitiveOrSequential;
        this.tooShort = dto.tooShort;
    }

    get hasViolations() {
        return (
            this.hasCommonNames ||
            this.hasRepetitiveOrSequential ||
            this.tooShort
        );
    }
}

export class HeaderLink implements IHeaderLink {
    rel: string;
    hrefLang: string;
    href: string;

    constructor(dto: IHeaderLink) {
        this.rel = dto.rel;
        this.hrefLang = dto.hrefLang;
        this.href = dto.href;
    }

}

export class LinkLanguage implements ILinkLanguage {
    hrefLang: string;
    queryStringLang: string;

    constructor(dto: ILinkLanguage) {
        this.hrefLang = dto.hrefLang;
        this.queryStringLang = dto.queryStringLang;
    }
}

export default {
    ProfileInfo,
    LinkLanguage,
};
